import React, {useState, useCallback, useContext, useEffect} from 'react';
import { useForm } from 'react-hook-form';
import { useMutation, useLazyQuery} from '@apollo/client';

import DataState from 'app/src/components/DataState';
import AuthContext from 'app/src/contexts/AuthContext';
import Input from 'app/src/elements/inputs';
import { Button, ButtonGroup, ButtonContainer } from 'app/src/elements/buttons';
import { View, Text } from 'react-native';
import { UPDATE_FEE, SELECTS } from './queries';
import { formatAssetNameForSelect } from '../../utils/formatAssetName';
import Autocomplete from '../Autocomplete';
import { NewAttachments } from '../Attachments/new';
import EditLinkedAttachment from '../Attachments/LinkedAttachments/edit';

const EditFee = ({
  setShowModal, refetch, fee, feeEstimate, asset, fromSalesProcess
}) => {
  const { feeTypes } = useContext(AuthContext);
  const [submitting, setSubmitting] = useState();
  const [assets, setAssets] = useState();
  const [userOptions, setUserOptions] = useState();
  const [files, setFiles] = useState(
    feeEstimate ? feeEstimate.feeEstimateFiles : fee.feeFiles
  );
  const [linkedAttachments, setLinkedAttachments] = useState(
    fee?.linkedAttachments.map(attachment => {
      return {
        id: attachment.id,
        name: attachment.name,
        url: attachment.url,
        resourceId: attachment.resourceId,
        resourceType: attachment.resourceType
      }
    })
  );
  const [updateFee] = useMutation(UPDATE_FEE, {
    onCompleted: () => {
      refetch();
      setShowModal(false);
    }
  });

  const [ loadSelectOptions, { loading: loading, data: data } ] =
    useLazyQuery(SELECTS, {
      onCompleted: () => setUserOptions(data?.users)
    }
  );

  const onSubmit = useCallback(input => {
    setSubmitting(true);
    if(input['acceptedByMethod'] === '') {
      input['acceptedByMethod'] = undefined;
    }
    if(input['linkedAttachments']) {
      input['linkedAttachmentAttributes'] = linkedAttachments;
      delete input['linkedAttachments'];
    }
    updateFee({ variables: input });
  });

  const { control, handleSubmit, register, setValue, formState: { errors } } = useForm({
    defaultValues: {
      id: fee.id,
      type: fee.type || '',
      buyerFee: fee.buyerFee || false,
      assetId: fee.asset?.id || '',
      saleAssetId: fee.saleAsset?.id || '',
      amount: fee.amount || '',
      description: fee.description || '',
      acceptedById: fee.acceptedBy?.id || '',
      acceptedByMethod: fee.acceptedByMethod || '',
      feeFiles: fee.feeFiles || [],
      feeEstimateFiles: feeEstimate?.feeEstimateFiles || [],
      linkedAttachments: fee.linkedAttachments || []
    }
  });

  useEffect(() => {
    if(fromSalesProcess && !userOptions) {
      loadSelectOptions();
    }
  }, [])

  return (
    <View>
      {submitting ?
        <DataState.Loading /> :
        <View>
          {/* <Input.Text
            label="Type:"
            name="type"
            control={control}
            errors={errors}
            id="type"
            {...register("type", {
              required: "Type is required",
              validate: {
                maxLength: (v) =>
                  v.length <= 10 || "The type should have at most 10 characters",
              },
            })}
          /> */}
          <Input.Picker
            label="Type:"
            name="type"
            options={feeTypes}
            control={control}
            errors={errors}
          />
          <Input.Checkbox
            label="Buyer Fee?"
            name="buyerFee"
            control={control}
            errors={errors}
          />
          {/* <Input.Picker
            label="Asset:"
            name="assetId"
            options={assets}
            control={control}
            errors={errors}
          /> */}
          { asset ?
            <></>
            :
            <Autocomplete
              label={'Asset'}
              placeHolder={''}
              resource={'Asset'}
              options={assets}
              setValue={setValue}
              name='assetId'
            />
          }
          <Input.Currency
            label="Amount:"
            name="amount"
            control={control}
            errors={errors}
            id="amount"
            {...register("amount", {
              required: "Amount is required",
              validate: {
                matchPattern: (v) =>
                  /\d{1,10}(\.{1}\d{1,2}){0,1}?$/.test(v) ||
                  "Please use number only without commas",
              },
            })}
          />
          <Input.Text
            label="Description:"
            name="description"
            control={control}
            errors={errors}
          />
          {fromSalesProcess &&
            <View>
              <Input.Picker
                label="Accepted By:"
                name="acceptedById"
                options={
                  userOptions?.map(user => { return { value: user.id, label: user.fullName }})
                }
                control={control}
                errors={errors}
              />
              <Input.Picker
                label="Accepted Method:"
                name="acceptedByMethod"
                options={
                  ['Email', 'Call'].map(type => { return { value: type, label: type }})
                }
                control={control}
                errors={errors}
              />
            </View>
          }
          <Text style={{marginBottom: '-15px', fontSize: '16px'}}>
            {feeEstimate ? 'Fee Estimate Files:' : 'Fee Files:'}
          </Text>
          <NewAttachments
            recordId={feeEstimate ? feeEstimate?.id : fee?.id}
            recordType={feeEstimate ? 'FeeEstimate' : 'Fee'}
            attachmentType={feeEstimate ? 'Fee Estimate File' : 'Fee File'}
            refetch={refetch}
            name={feeEstimate ? 'feeEstimateFiles' : 'feeFiles'}
            setValue={setValue}
            existingFiles={files}
          />
          {!feeEstimate &&
            <View>
              <b>OR</b>
              <EditLinkedAttachment
                linkedAttachments={linkedAttachments}
                resourceId={fee?.id}
                resourceType={'Fee'}
                setValue={setLinkedAttachments}
                multi={true}
              />
            </View>
          }
          <ButtonContainer>
            <ButtonGroup>
              <Button label="Update Fee" onPress={handleSubmit(onSubmit)} />
            </ButtonGroup>
          </ButtonContainer>
        </View>
      }
    </View>
  )
}

export default EditFee;
